<template>
  <div class="page_warp auto">
    <button @click="goMiniPage('/pages/shop/index')">旧版商城</button>
    <button @click="goMiniPage('/pagesMall/index')">新版商城</button>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    goMiniPage (route) {
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
          //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
          this.$wx.miniProgram.getEnv((res)=>{
            if (res.miniprogram) {
                
              this.$wx.miniProgram.navigateTo({
                url: route
              })

            } else {
                console.log("不在小程序里");
            }
          })
      }else{
          window.uni.navigateTo({
            url: route
          })
      }
    }
  }
}
</script>

<style scoped>
.page_warp {
  text-align: center;
  background: #a9cae8;
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
}
button {
  width: 90%;
  height: 40px;
  margin: 20px 0;
  font-size: 18px;
  background: #fff;
  border-radius: 4px;
}
</style>